// extracted by mini-css-extract-plugin
module.exports = {"slider":"CardCarouselV2_slider__3m0Vp"};